module.exports = new __parcel__URL__("space_elixir_storage_level_13.0f4c8690.png").toString();